import { Link } from 'react-router-dom';
import { ShieldOff, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function SinPermisoPage() {
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-6">
      <div className="h-16 w-16 rounded-full bg-amber-50 ring-1 ring-amber-200 flex items-center justify-center mb-5">
        <ShieldOff className="h-8 w-8 text-amber-700" />
      </div>
      <h2 className="text-2xl font-bold tracking-tight text-foreground">Sin permiso de acceso</h2>
      <p className="text-sm text-muted-foreground mt-2 max-w-md">
        Tu rol no tiene autorización para ver esta sección. Si crees que es un error, contacta al administrador.
      </p>
      <Button asChild className="mt-6">
        <Link to="/">
          <ArrowLeft className="h-4 w-4" />
          Volver al inicio
        </Link>
      </Button>
    </div>
  );
}
